<div class="row">
  <div class="col-12">
    <h1>Session Details</h1>
  </div>
  <div class="col-12">
    <h3>Session {{this.sessionKey}}</h3>
  </div>
  <div class="col-12">
    <h3>
      <button class="btn btn-default" (click)="goBack()">Back</button>
      <button class="btn btn-danger" (click)="cancelSession()"  *ngIf="documentSession.status === 'IN-Progress'">Cancel Session</button>
    </h3>
  </div>
</div>

<div class="row">
  <div class="col-12 col-sm-6 col-lg-4">
    <dl class="dl-horizontal">
      <dt>Move Date/Time:</dt>
      <dd>{{documentSession.movedDateTime}}</dd>
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-lg-4">
    <dl class="dl-horizontal">
      <dt>Total Residents:</dt>
      <dd>{{documentSession.sourceSession.residents.length}}</dd>
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-lg-4">
    <dl class="dl-horizontal">
      <dt>Document Types:</dt>
      <dd>{{documentSession.sourceSession.sourceDocTypes.length}}</dd>
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-lg-4">
    <dl class="dl-horizontal">
      <dt>Moved By:</dt>
      <dd>{{documentSession.movedBy}}</dd>
    </dl>
  </div>
  <div class="col-12 col-md-6">
    <dl class="dl-horizontal">
      <dt>Attached Date Range:</dt>
      <dd>{{documentSession.sourceSession.dateRange}}</dd>
    </dl>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12">
    <table class="table table-bordered table-striped">
      <thead>
      <tr>
        <th>Parameters</th>
        <th>Moving From</th>
        <th>Moving To</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Environment</td>
        <td>{{documentSession.sourceSession.sourceEnvironmentName}}</td>
        <td>{{documentSession.destinationSession.destinationEnvironmentName}}</td>
      </tr>
      <tr>
        <td>Corporation</td>
        <td>{{documentSession.sourceSession.sourceCorporationName}}</td>
        <td>{{documentSession.destinationSession.destinationCorporationName}}</td>
      </tr>
      <tr>
        <td>Facility</td>
        <td>{{documentSession.sourceSession.sourceFacilityName}}</td>
        <td>{{documentSession.destinationSession.destinationFacilityName}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>


<div class="row">
  <div class="col-12 col-md-4">
    <h3 class="mt-4">Document Transfers
    </h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <table class="table table-bordered table-striped table-fit" id="residentList" #residentList>
    </table>
  </div>
</div>

<ng-template #modalContent let-closeResult="close" let-dismissResult="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{patientName}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissResult('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-sm-6">
        <dl class="dl-horizontal">
          <dt>Documents Not Moved:</dt>
          <dd>{{documentsNotMoved}}</dd>
        </dl>
      </div>
      <div class="col-12 col-sm-6">
        <dl class="dl-horizontal">
          <dt>Documents Moved:</dt>
          <dd>{{documentsMoved}}</dd>
        </dl>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-striped mt-3">
          <thead>
          <tr>
            <th>Documents Not Moved</th>
            <th>Reason</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let ed of errorDocumentList">
            <td *ngIf="ed.originalFileName?.length > 0">
              {{ ed.documentTransferStatus.fileNameOfDocumentsNotMoved}}
            </td>
            <td *ngIf="ed.originalFileName?.length <= 0">
              {{ed.documentTitle}}
              &nbsp;&nbsp;
              Attached Date: {{ ed.assignedDate | date: 'MM/dd/yyyy' }}
            </td>
            <td class="wrapword">
              {{ ed.documentTransferStatus.errorMessageForDocument}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="closeResult('Close click')">Close</button>
  </div>
</ng-template>
